import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => {
        setOpen(false);
        cycleTimer = window.setTimeout(show, GAP);
      }, SHOW_FOR);
    };
    cycleTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const initials = buyer.name.split(" ").map(p => p[0]).join("");
  return <AnimatePresence data-id="element-40" data-mp="1fwbvlreuyso9">
      {open && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[96px] left-3 right-3 z-50 mx-auto flex max-w-sm items-center gap-3 rounded-2xl border border-petal bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(43,27,34,0.35)] sm:right-auto md:bottom-28 md:left-6" data-id="element-41" data-mp="1fxvc9j4ff5qk">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-berry font-serif text-[15px] font-bold text-white" data-id="element-42" data-mp="28kg4smwn1nvp">
            {initials}
          </span>
          <div className="min-w-0 text-[13px] leading-snug" data-id="element-43" data-mp="23npp40oqwuat">
            <p className="text-ink" data-id="element-44" data-mp="2anrur3odj6gw">
              <strong data-id="element-45" data-mp="2aqxl0m8qoee7">{buyer.name}</strong> from {buyer.place}
            </p>
            <p className="text-muted" data-id="element-46" data-mp="2flte7pppp7sw">
              just purchased <strong className="text-berry" data-id="element-47" data-mp="2km7qjjycj3wq">Nail Course In A Box™</strong>
            </p>
            <p className="mt-0.5 flex items-center gap-1 text-[12px] text-muted" data-id="element-48" data-mp="2plk9htm3jqu1">
              <BadgeCheckIcon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-49" data-mp="1ry3gyncnm6or" />
              Verified purchase · {minutes} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-blush hover:text-ink" aria-label="Close notification" data-id="element-50" data-mp="1wxoj16n4ev5p">
            <XIcon className="h-4 w-4" data-id="element-51" data-mp="196sr89inzzyg" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}